import {put, call, cancel} from 'redux-saga/effects';
import Creators, {forgetPasswordFailed} from '../state/AppRedux';
import {authenticationService} from '../services/authenticationService';
import {validateFormErrorResponse} from '../helpers';
import {navigate} from 'gatsby';

// login
export function* authenticate(data) {
	// console.log('in authenticate saga');
	// enable loading indicator
	yield put(Creators.loggingIn());
	
	let authenticationResult = null;
	try {
		authenticationResult = yield call(authenticationService.login, data);
		if (authenticationResult.data.response) {
			yield put(Creators.loginSuccessful(authenticationResult.data.response));
		}
	} catch (e) {
		if (e.status === 401) {
			yield put(Creators.logout());
			navigate('/');
		}
		const validationMessages = validateFormErrorResponse(e.data.response);
		yield put(Creators.loginFailed(validationMessages));
	}
}


// Forget Password Request
export function* forgetPasswordRequest(data) {
	yield put(Creators.fetching());
	
	let result = null;
	try {
		result = yield call(authenticationService.forgetPassword, data);
		if (result.data.response) {
			yield put(Creators.forgetPasswordSuccessful(result.data.response));
		}
	} catch (e) {
		if (e.status === 401) {
			yield put(Creators.logout());
			navigate('/');
		}
		const validationMessages = validateFormErrorResponse(e.data.response);
		yield put(Creators.forgetPasswordFailed(validationMessages));
	}
}

// update password
export function* updatePasswordRequest(data) {
	yield put(Creators.fetching());
	
	let result = null;
	try {
		result = yield call(authenticationService.updatePassword, data);
		if (result.data.response) {
			yield put(Creators.updatePasswordSuccessful(result.data.response));
		}
	} catch (e) {
		if (e.status === 401) {
			yield put(Creators.logout());
			navigate('/');
		}
		const validationMessages = validateFormErrorResponse(e.data.response);
		yield put(Creators.updatePasswordFailed(validationMessages));
	}
}

export function * getAvailableActions (action) {
	// Dispatch a redux action using `put()`
	// @see https://redux-saga.js.org/docs/basics/DispatchingActions.html
	yield put(Creators.fetchingActions());
	
	// Fetch the temperature from an API
	let availableActions = null;
	try {
		availableActions = yield call(authenticationService.getActions, action);
		// console.log(availableActions);
	} catch (e) {
		// console.log(e);
		availableActions = e;
		//bugsnag.notify(e)
	}
	
	if (availableActions && availableActions.status === 200) {
		yield put(Creators.actionsFetchSuccess(availableActions.data.response));
	} else {
		if (availableActions.data !== null && typeof availableActions.data === 'object') { // for request time out logging
			if (availableActions.data.code === 412) {
				yield put(Creators.resetAuthToken(true));
				navigate('/login', {
					state: {
						redirectMessage: 'Please login to continue'
					}
				});
				//action.navigation.navigate('LoginScreen', { redirectMessage: 'Please login to continue.', replace: true })
			} else {
				//bugsnag.notify(availableActions)
				yield put(Creators.actionsFetchFailed(availableActions.data.response));
			}
		} else { // log timed out requests
			//bugsnag.notify(availableActions)
			yield put(Creators.actionsFetchFailed(availableActions.data));
		}
	}
}
